<app-navigation-confirm-dialog
  [isVisible]="showCloseConfirmDialog()"
  [title]="dialogTitle()"
  [messageCategory]="dialogCategory()"
  [message]="closeConfirmMessage()"
  [okLabel]="okLabel()"
  [cancelLabel]="cancelLabel()"
  (confirmed)="onCloseWindowConfirmed()"
  (cancelled)="onCloseWindowCancelled()"
></app-navigation-confirm-dialog>
@if (showEmulationHeader) {
<app-emulation-header #emulationHeader (customerUsage)="onCustomerUsageClick()"
  (logout)="onEmulationLogout()"></app-emulation-header>
}
<app-page-header
  [isMenuOpen]="isMenuOpen()"
  (menuOpen)="openMenu()"
  (menuClose)="closeMenu()"
  (faqClick)="onHeaderFaqClick()"
  (closeWindowClick)="onHeaderCloseWindowClick()"
></app-page-header>
@if (isMenuOpen()) {
  <app-nav-menu [isOpen]="isMenuOpen()" [items]="menuItems" (closeMenu)="closeMenu()"
    (itemClick)="onMenuItemClick($event)"></app-nav-menu>
}
<div class="main-content" [hidden]="isMenuOpen()" [attr.aria-hidden]="isMenuOpen()">
  <router-outlet />
</div>
@if (showScrollToTopButton() && !isMenuOpen()) {
<app-scroll-to-top-button />
}
<app-page-footer (closeClick)="onFooterCloseClick()"></app-page-footer>